'use strict';

// https://docs.angularjs.org/guide/compiler#directive

angular.module('paizacloudApp')
  .directive('draggable', function($document) {
    return {
      // template: '<div></div>',
      restrict: 'EA',
      link: function(scope, element, attrs) {
        var startX = 0, startY = 0, x = 0, y = 0;

        if(element.css('position') === 'static'){
          element.css('position', 'relative');
        }

        element.on('mousedown', function(event){
          event.preventDefault();
          startX = event.screenX - x;
          startY = event.screenY - y;
          $document.on('mousemove', mousemove);
          $document.on('mouseup', mouseup);
        });

        function mousemove(event){
          x = event.screenX - startX;
          y = event.screenY - startY;
          element.css({
            top: y + 'px',
            left: x + 'px',
          });
        }

        function mouseup(event){
          $document.off('mousemove', mousemove);
          $document.off('mouseup', mouseup);
        }

      }
    };
  });
